// Higher number, higher priority
// Id must be unique for each modal instance otherwise it will not work as expected.
const PRIORITY_OF_MODAL = {
  veroModal: 0,
  'kiosk-toc': 0, // terms and conditions for kiosk
  'experience-booking-error-dialog': 1,
  'accommodation-confirmation-error-dialog': 1,
  'guest-selection-popup': 1,
  'search-filters-popup': 1,
  'saved-card': 1,
  'amendment-fees': 1,
  'service-form-error-dialog': 1,
  'optional-extra-form-error-dialog': 1,
  'generic-ticket-form-error-dialog': 1,
  'summary-of-changes': 1,
  'gift-voucher-error-dialog': 1,
  'vehicle-modal-link': 1,
  'consumer-based-ticket-form-error-dialog': 1,
  'multiple-booking-warning': 2,
  'tenant-switch-warning': 2,
  'experience-expiry-check': 3,
  'site-wide-navigation-expiry': 3,
  'abandon-cart-modal': 4,
  'login-alert-modal': 9,
  'sea-breeze-checkout-form-dialog': 9,
  'sealink-checkout-form-dialog-payment-pending': 9,
  'sealink-checkout-form-dialog-error': 9,
  'rebuild-cart': 9,
  'continue-editing': 10,
  'discard-booking-changes': 10,
};

const getPriorityFromId = (id) => {
  const priority = PRIORITY_OF_MODAL[id];
  return priority === undefined ? -1 : priority;
};

let stateMap = {};
// Only display the modal one at a time.
let currentModalInDisplay = '';
// Modals waiting to be displayed.
let modalsToBeDisplayed = [];

export const resetModalController = () => {
  stateMap = {};
  currentModalInDisplay = '';
  modalsToBeDisplayed = [];
};

export const registerModal = ({ id, onVisibleChange }) => {
  if (!id) {
    return;
  }
  const revokable = Proxy.revocable(
    { show: false },
    {
      set(obj, key, value) {
        obj[key] = value;
        if (key === 'show') {
          onVisibleChange?.(value);
        }

        return true;
      },
    }
  );

  stateMap[id] = revokable.proxy;
  return revokable;
};

export const requestToShow = ({ id }) => {
  if (!currentModalInDisplay) {
    // No modal is in display, show the modal immediately.
    currentModalInDisplay = id;
    stateMap[id].show = true;
  } else if (id === currentModalInDisplay) {
    // It's showing at the moment, do nothing.
  } else {
    const priorityOfCurrent = getPriorityFromId(currentModalInDisplay);
    const priorityOfRequest = getPriorityFromId(id);
    if (priorityOfRequest >= priorityOfCurrent) {
      // Modal from request has higher priority, hide the current one.
      stateMap[currentModalInDisplay].show = false;
      modalsToBeDisplayed.push(currentModalInDisplay);
      // Show the modal from request. Add some delay otherwise the modal will malfuction.
      setTimeout(() => {
        stateMap[id].show = true;
        currentModalInDisplay = id;
      }, 500);
    } else {
      // add the modal from request to the queue.
      modalsToBeDisplayed.push(id);
    }
  }
};

function popNextModalToShow() {
  return (
    modalsToBeDisplayed
      .sort((a, b) => getPriorityFromId(a) - getPriorityFromId(b))
      .pop() || ''
  );
}

export const requestToHide = ({ id }) => {
  if (id === currentModalInDisplay) {
    stateMap[id].show = false;
    currentModalInDisplay = popNextModalToShow();
    if (currentModalInDisplay) {
      setTimeout(() => {
        stateMap[currentModalInDisplay].show = true;
      }, 500);
    }
  } else {
    const index = modalsToBeDisplayed.indexOf(id);
    if (index !== -1) {
      modalsToBeDisplayed.splice(index, 1);
    }
  }
};
